const footer = {
    text: "We gebruiken cookies om ervoor te zorgen dat onze website compleet functioneert. Als je doorgaat met het gebruiken van de website, gaan we er vanuit dat er mee instemt.",
    button: "Oké!"
}
export default footer;